module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/un-19c1ad320e901a90c0e31c38039a0f27.svg";